import { dddd } from './testen'

export default {
  I18n: {
    ...dddd,
    仪表盘: 'Dashboard',
    工作台: 'Workbench',
    更新日志: 'Change log',
    配置: 'Settings',
    用户管理: 'User management',
    角色管理: 'Role management',
    部门管理: 'Department management',
    菜单管理: 'Menu management',
    组件: 'Part',
    角色权限控制: 'Roles',
    外链: 'External links',
    图标: 'Icon',
    常规图标: 'Awesome icon',
    小清新图标: 'Remix icon',
    多彩图标: 'Colorful icon',
    图标选择器: 'Icon selector',
    表格: 'Table',
    综合表格: 'Comprehensive table',
    行内编辑表格: 'Inline edit table',
    自定义表格: 'Custom table',
    表单: 'Form',
    综合表单: 'Comprehensive form',
    数字自增长: 'count',
    分步表单: 'Step form',
    动态标题: 'Dynamic title',
    动态路径参数: 'Dynamic segment',
    拖拽: 'Drag',
    弹窗拖拽: 'Dialog drag',
    卡片拖拽: 'Card drag',
    流程图拖拽: 'Flowsheet Drag',
    右键菜单: 'Contextmenu',
    卡片: 'Card',
    多级路由缓存: 'Menu1',
    '多级路由1-1': 'Menu1-1',
    '多级路由1-1-1': 'Menu1-1-1',
    加载: 'Loading',
    视频播放器: 'Player',
    编辑器: 'Editor',
    Markdown编辑器: 'Markdown editor',
    富文本编辑器: 'Rich text editor',
    上传: 'Upload',
    错误日志模拟: 'Log',
    Excel: 'Excel',
    导出Excel: 'Export excel',
    导出选中行Excel: 'Export selected excel',
    导出合并Excel: 'Export merge header excel',
    Css动画: 'Cssfx',
    第三方登录: 'Social login',
    物料源: 'Material',
    物料市场: 'Material Market',
    错误页: 'Error',
    403: '403',
    404: '404',
    邮件: 'Email',
    清空消息: 'Clear Message',
    更多: 'More',
    关闭其他: 'Close other',
    关闭左侧: 'Close left',
    关闭右侧: 'Close right',
    关闭全部: 'Close all',
    退出登录: 'Logout',
    登录: 'Login',
    注册: 'register',
    主题配置: 'Theme',
    主题: 'Theme',
    默认: 'Default',
    海洋之心: 'Ocean',
    绿荫草场: 'Green',
    荣耀典藏: 'Glory',
    碰触纯白: 'White',
    布局: 'layouts',
    画廊: 'Gallery',
    纵向: 'Vertical',
    横向: 'Horizontal',
    综合: 'Comprehensive',
    常规: 'Common',
    画廊风格: 'Gallery style',
    头部: 'Header',
    固定: 'Fixed',
    不固定: 'No fixed',
    多标签: 'Tgs',
    国际化: 'Language',
    进度条: 'Progress',
    刷新: 'Refresh',
    通知: 'Notice',
    全屏: 'Full Screen',
    搜索: 'Search',
    显示: 'Show',
    不显示: 'Hide',
    随机换肤: 'Random',
    拷贝源码: 'Code',
    恢复默认: 'Defalut',
    保存: 'Save',
    欢迎来到: 'Welcome to',
    请输入用户名: 'Please enter one user name',
    请输入密码: 'Please input a password',
    用户名不能为空: 'The user name cannot be empty',
    密码不能少于6位: 'The password cannot be less than 6 digits',
    请输入正确的手机号: 'Please enter the correct mobile phone number',
    请输入手机号: 'Please enter your mobile phone number',
    请输入手机验证码: 'Please input the mobile phone verification code',
    获取验证码: 'Get captcha',
  },
}
